import { useMyStore } from "src/components/main/mainStore";
import WorkLogForm from "../workLogForm";
//---------------------------------------------------
export default function NearMissForm({
    ...rest
}){
     const user = useMyStore(state => state.user);
    //--------------------------------------------------------------------------------------------
    const items = [
        {title: "Individual Reporting", type: "text", required: true, default: user.userName}, 
        {title: "Date", type: "date", required: true}, 
        {title: "Time", type: "time"}, 
        {title: "Location", type:"text", required: true}, 
        {title: "BTL Associated", type: "text", required: true}, 
        {title: "What happened? How did you react to help/assist? Who was involved? When did you notice? Where did the details of the event occur?", type: "textarea", required: true},
    ];
    const Pre = <div className = "my-2 text-secondary font-weight-bold font-italic">
        <p>
            A Near Miss is an incident that took place without property damage or personal injury/illness, but were given a shift intime or position, damage or injury easily could have occurred.
        </p>
        <p>
            Un cuasi accidente es un incidente que tuvo lugar sin daños a la propiedad o lesiones / enfermedades personales, pero cuando se le dio un cambio en el tiempo o la posición, el daño o la lesión fácilmente podrían haber ocurrido.
        </p>
    </div>;
    //--------------------------------------------------------------------------------------------
    return(
        <WorkLogForm
            sendEmail
            correctiveActionNeed = {true}
            prefix = {Pre}
            picsLimit = {0}
            items = {items}
            {...rest}
        />
    )    
}